'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableResizeHandle", {
    enumerable: true,
    get: function() {
        return TableResizeHandle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableResizeHandle = require("./useTableResizeHandle");
const _renderTableResizeHandle = require("./renderTableResizeHandle");
const _useTableResizeHandleStylesstyles = require("./useTableResizeHandleStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableResizeHandle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableResizeHandle.useTableResizeHandle_unstable)(props, ref);
    (0, _useTableResizeHandleStylesstyles.useTableResizeHandleStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableResizeHandleStyles_unstable')(state);
    return (0, _renderTableResizeHandle.renderTableResizeHandle_unstable)(state);
});
TableResizeHandle.displayName = 'TableResizeHandle';
